import React from "react";
import Modal from "@components/atoms/Modal";
import { VDBText } from "@components/atoms";
import styled from "styled-components/native";
import { TouchableOpacity } from "react-native";
import { useTheme } from "styled-components/native";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { SpaceType } from "@components/atoms/Spacer/types";

type OptionsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  options: Record<string, any>;
  onOptionSelect: (optionName: string) => void;
  t: any;
  priceMode: number;
  title: string;
  isMyInventory: boolean;
};

const OptionsModal = ({
  isOpen,
  onClose,
  options,
  onOptionSelect,
  t,
  priceMode,
  title,
  isMyInventory = false,
}: OptionsModalProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const filteredOptions = Object.entries(options).reduce(
    (acc, [key, option]) => {
      if (option.price_modes && option.price_modes.includes(priceMode)) {
        acc[key] = option;
      }
      return acc;
    },
    {}
  );

  return (
    <Modal
      headerTitle={t(title) || t("productDetailPage.request.options.text")}
      isOpen={isOpen}
      onClose={onClose}
    >
      <OptionsContainer>
        {Object.entries(filteredOptions).map(([key, option]) => (
          <OptionButton key={key}>
            <TouchableOpacity
              onPress={() => {
                onClose();
                onOptionSelect(option.name);
              }}
              disabled={option?.disabled}
            >
              <OptionRow>
                <LeftSection>
                  {option?.icon?.data && (
                    <IconContainer>
                      <VDBIcon
                        name={option.icon.data}
                        size={24}
                        color={theme["core-05"]}
                        variant={IconsVariant.VDBCustom}
                      />
                    </IconContainer>
                  )}
                  <VDBText
                    type={typography["H3-M"]}
                    color={
                      option?.disabled ? theme["core-04"] : theme["core-05"]
                    }
                  >
                    {isMyInventory && option?.name === "request_item"
                      ? t(
                          "productDetailPage.soldReturn.button.text",
                          "Sold/Return"
                        )
                      : t(option?.label)}
                  </VDBText>
                </LeftSection>
                <VDBIcon
                  name={VDBIcons.ARROW_RIGHT}
                  size={24}
                  color={option?.disabled ? theme["core-04"] : theme["core-04"]}
                  variant={IconsVariant.VDBCustom}
                />
              </OptionRow>
            </TouchableOpacity>
          </OptionButton>
        ))}
      </OptionsContainer>
    </Modal>
  );
};

const OptionsContainer = styled.View`
  width: 100%;
  margin-bottom: ${SpaceType.ExtraLarge}px;
`;

const OptionButton = styled.View`
  width: 100%;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme["core-03"]};
`;

const OptionRow = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${SpaceType.Double}px;
`;

const LeftSection = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${SpaceType.Extra}px;
`;

const IconContainer = styled.View`
  justify-content: center;
  align-items: center;
`;

export default OptionsModal;
